import { FieldValues } from "react-hook-form";
import { Field } from "./Field";
import { useEffect } from "react";
import { Icon } from "@thetreep/ui";
import { getColor } from "@utils/colors";

interface SelectToggleProps<T extends FieldValues, K extends keyof T> {
  field: Field<T, K>;
  value?: T[K];
  onChange: (value: T[K]) => void;
}

export function SelectToggle<T extends FieldValues, K extends keyof T>({
  field,
  value,
  onChange,
}: SelectToggleProps<T, K>) {
  useEffect(() => {
    if (!value && field.options) {
      onChange(field.creation?.defaultValue || field.options[0].value);
    }
  }, []);

  if (!field.options) {
    return null;
  }

  return (
    <div className="flex w-full">
      {field.options.map((o, i) => (
        <button
          data-testid={`toggle-${String(field.key)}-${o.value}`}
          className={`
                    flex flex-1 sm:flex-none items-center justify-center gap-2
                    px-2 sm:px-4 py-2
                    font-bold
                    sm:whitespace-nowrap
                    border-t border-b border-r
                    border-cnam-blue
                    ${
                      value == o.value
                        ? "bg-cnam-blue text-white"
                        : "bg-white text-cnam-blue"
                    }
                    ${i === 0 && "rounded-l border-l"}
                    ${i + 1 === field.options?.length && "rounded-r"}
                    `}
          key={o.label}
          onClick={() => onChange(o.value)}
          type="button"
        >
          {o.icon && (
            <Icon
              src={o.icon}
              color={value === o.value ? "white" : getColor("cnam-blue")}
            />
          )}
          {o.label}
        </button>
      ))}
    </div>
  );
}
